var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-photo",style:(_vm.componentStyle),attrs:{"width":_vm.photoSize,"height":_vm.photoSize}})}
var staticRenderFns = []

export { render, staticRenderFns }